export enum LANDING_PAGE_INFO {
  REFERRALS = 'referrals',
  FASTER_BOOKING = 'faster-booking',
  EASIER_MANAGEMENT = 'easier-management',
}

export enum CLOSE_SESSION_TYPES {
  NONE = 'none',
  NOTE_NEEDED = 'noteNeeded',
  INVOICE_NEEDED = 'invoiceNeeded',
  SESSION_TO_CLOSE = 'sessionToClose',
  INVOICE_AND_NOTE_NEEDED = 'invoiceAndNoteNeeded',
  NOTE_AND_INVOICE_COMPLETED = 'noteAndInvoiceCompleted',
  INVOICE_NEEDED_BY_ADMIN = 'invoiceNeededByAdmin',
  NOTE_NEEDED_BY_PROVIDER = 'noteNeededByProvider',
  LATE_CANCEL_COVERED = 'lateCancelCovered',
  LATE_CANCEL_CLIENT_OWED = 'lateCancelClientOwed',
}
